import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Actions as USAGEACTIONS } from '../../../store/actions/usageActions';
import { Button } from '../../ui/button';
import { Loader2, Trash2, Upload, CloudUpload } from 'lucide-react';

const UploadBtn = ({
  getUploadLink,
  processUpload,
  uploadType,
  usageUploadType,
  importUploadLink,
  importUploadKey,
  ...props
}) => {
  const [file, setFile] = useState(null);
  const [loader, setLoader] = useState(false);
  let { action, toggleModal } = props || {};
  let btnDisabled = false;
  let uploadTypeValue = {};
  let btnTitle, btnIcon;
  //let isInputDisabled = false;

  if (action === 'deleteOrgs') {
    btnDisabled = !file || !importUploadLink || !importUploadKey || loader;
    btnTitle = 'Delete Organisations';
    btnIcon = 'trash';
    uploadTypeValue = { label: 'Delete Organisations', value: 'deleteOrgs' };
  } else if (action === 'importMixedTemplates') {
    btnDisabled = !file || !importUploadLink || !importUploadKey || loader;
    btnTitle = 'Import Mixed Template';
    btnIcon = 'upload';
    uploadTypeValue = { label: 'Import Mixed Templates', value: 'importMixedTemplates' };
  }

  const selectFile = (e) => {
    const newFile = e.target.files && e.target.files[0];
    setFile(newFile);
    uploadType(uploadTypeValue);
    getUploadLink(newFile, action);
  };

  return (
    <div>
      {file ? (
        <Button
          variant='outline'
          id='action-file-btn'
          disabled={btnDisabled}
          onClick={async () => {
            setLoader(true);
            try {
              if (action === 'deleteOrgs') {
                await processUpload(file, action);
              } else if (action === 'importMixedTemplates') {
                await processUpload(file, action);
              }
            } catch (error) {
              console.log('Error:', error);
            } finally {
              setTimeout(() => {
                setLoader(false);
                toggleModal(false, null);
              }, 5000);
            }
          }}>
          {loader ? <Loader2 size={16} strokeWidth={1.5} className="animate-spin" style={{ marginRight: 5 }} /> : btnIcon === 'trash' ? <Trash2 size={16} strokeWidth={1.5} style={{ marginRight: 5 }} /> : <Upload size={16} strokeWidth={1.5} style={{ marginRight: 5 }} />}
          {btnTitle}
        </Button>
      ) : (
        <>
          <Button variant='outline' asChild>
            <label htmlFor='import_input' id='upload-file-btn' className='cursor-pointer'>
              {loader ? <Loader2 size={16} strokeWidth={1.5} className="animate-spin" style={{ marginRight: 5 }} /> : <CloudUpload size={16} strokeWidth={1.5} style={{ marginRight: 5 }} />}
              Upload File
            </label>
          </Button>
          <input
            id='import_input'
            type='file'
            disabled={file}
            accept='.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
            onChange={selectFile}
          />
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    usageUploadType: state.usageUploadType,
    importUploadLink: state.importUploadLink,
    importUploadKey: state.importUploadKey,
  };
};

const mapDispatchToProps = (dispatch) => ({
  processUpload: (file, action) => dispatch(USAGEACTIONS.processUpload(file, action)),
  getUploadLink: (file, action) => dispatch(USAGEACTIONS.getUploadLink(file, action)),
  uploadType: (file) => dispatch(USAGEACTIONS.uploadUsageType(file)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadBtn);
